// @owners { team: patients-team }
import { type UsersEndpointUpdateRequest } from '@alto/scriptdash/alto/med_sync/patients/v1/users_endpoint';
import { put } from '~shared/helpers/apiHelper';
import { useMutation } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
const updateMedSyncStatus = ({ id, params }: UsersEndpointUpdateRequest) => {
  return put(
    `/med_sync/users/${id}`,
    { params },
    {
      version: 'v1',
    },
  ).then((response) => {
    if (response.error) {
      throw new Error(response.error);
    }
    return response;
  });
};

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useUpdateMedSyncStatus = () => {
  return useMutation({
    mutationFn: ({ id, params }: UsersEndpointUpdateRequest) => {
      return updateMedSyncStatus({ id, params });
    },
  });
};
